// This icon file is generated automatically.
var PCloseSquareOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "g", "attrs": { "fill-rule": "nonzero" }, "children": [{ "tag": "path", "attrs": { "d": "M4.53 9.48h.92c.08 0 .15-.03.2-.08L7 7.78 8.36 9.4c.04.05.11.08.19.08h.92c.1 0 .16-.12.1-.2L7.64 7l1.92-2.28a.12.12 0 00-.1-.2h-.92a.25.25 0 00-.2.08L7 6.22 5.64 4.6a.25.25 0 00-.19-.08h-.92c-.1 0-.16.12-.1.2L6.36 7 4.44 9.28c-.07.08-.02.2.1.2z" } }, { "tag": "path", "attrs": { "d": "M12.75.75H1.25a.5.5 0 00-.5.5v11.5c0 .28.22.5.5.5h11.5a.5.5 0 00.5-.5V1.25a.5.5 0 00-.5-.5zm-.63 11.38H1.88V1.87h10.25v10.25z" } }] }] }, "name": "p-close-square", "theme": "outlined" };
export default PCloseSquareOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PCloseSquareOutlined.js
// module id = 3286
// module chunks = 0